module.exports = __webpack_public_path__ + "img/2d5c14e.svg";